import { RPProvider, RPDefaultLayout, RPPages, RPConfig } from '@pdf-viewer/react'
import c from "../../services/constants.json"
import { useEffect } from 'react';
import { SPDFViewerModal } from './styles';

const PDFViewer = ({file, close}) => {
    console.log("relatorio:", file);

    const removeWaterMark = () => {
        const div = document.querySelector('[data-rp="pages"]');
        if(div) {
            const child = div.firstElementChild
            child.setAttribute("style", "display:none;");
        }
    }
    useEffect(() => {
        removeWaterMark()
        const intervalId = setInterval(removeWaterMark, 500)
        return () => clearInterval(intervalId);
    },[])
    return (
        <SPDFViewerModal>
            <div className='modal-box'>
                <div className='p-2 d-flex justify-content-between'>
                    <a href={c.WSSERVER+"/"+file} target='_blank'><b>Abrir PDF</b></a>
                    <i class="fa-solid fa-xmark" style={{fontSize: 24, paddingRight: 12}} onClick={close}/>
                </div>
                <RPConfig>
                    <RPProvider src={c.WSSERVER+"/"+file}>
                        <RPDefaultLayout style={{ height: '660px' }}>
                        <RPPages />
                        </RPDefaultLayout>
                    </RPProvider>
                </RPConfig>
            </div>
        </SPDFViewerModal>
    )
}

export default PDFViewer